import { useFolder } from 'hooks/queries/folders/useFolder'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { FolderPreloaderProps } from './Types'

const FolderPreloader = observer(({ children, fileId }: FolderPreloaderProps) => {
  const { files } = useRootStore()
  const folderQuery = useFolder(fileId, { cacheTime: Infinity, enabled: false })

  return (
    <div
      onMouseEnter={() => {
        files.fetch(fileId)
        if (!folderQuery.data) {
          folderQuery.refetch()
        }
      }}
    >
      {children}
    </div>
  )
})

export { FolderPreloader }
